var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.084,
    height: 30.084,
    viewBox: "0 0 30.084 30.084",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook",
    transform: "translate(0.004 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2617",
    "data-name": "Raggruppa 2617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3472",
    "data-name": "Tracciato 3472",
    d: "M30.08,15.132a15.042,15.042,0,1,0-17.394,14.95V19.507H8.87V15.134h3.82V11.8c0-3.792,2.247-5.886,5.681-5.886a23.005,23.005,0,0,1,3.367.3V9.928h-1.9a2.181,2.181,0,0,0-2.45,2.365v2.839h4.17L20.9,19.5H17.39V30.08A15.109,15.109,0,0,0,30.08,15.132Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook_icon.c63bc6aa5b994971ffa4c34297cebdf7.svg";
export { ForwardRef as ReactComponent };